import type { ReactNode } from "react";

// Compact empty-state card for operator list/availability surfaces.
// Presentational only — no behavior, no funds, no network.

export function EmptyState({
  title,
  hint,
  action,
}: {
  title: string;
  hint?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div
      style={{
        margin: "12px 0",
        padding: "20px 16px",
        border: "1px dashed var(--border, #ccc)",
        borderRadius: 8,
        background: "var(--bg-card)",
        textAlign: "center",
      }}
    >
      <p style={{ margin: 0, fontSize: 14, fontWeight: 600 }}>{title}</p>
      {hint && (
        <p style={{ margin: "6px 0 0 0", fontSize: 12, color: "var(--fg-dim)" }}>{hint}</p>
      )}
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}
